import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "charts",
  "use": "charts-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"charts\"><path d=\"m15 12.59-6-6-3 3-1.5-1.5-4.5 4.5v2.58C0 17.84 2.17 20 4.83 20h10.33c2.67 0 4.83-2.17 4.83-4.83V7.59zm3 2.58c0 1.56-1.27 2.83-2.83 2.83H4.83C3.27 18 2 16.73 2 15.17v-1.75l2.5-2.5 1.5 1.5 3-3 6 6 3-3zM2 6.41l2-2 2 2 3.5-3.5 5.5 5.5 2-2 .67.67 1.41-1.41L17 3.59l-2 2L9.5.09 6 3.59l-2-2-4 4v4.17l2-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol